$(function () {
    const modal = document.getElementById('schedule-payment-warning');
    const params = new URLSearchParams(window.location.search);
    const nonce = params.get('payment_return');
    if (!modal && !nonce) return;
    const url = '/schedule/ajax-payment-methods/' + (nonce ? '?payment_return=' + encodeURIComponent(nonce) : '');
    $.getJSON(url).done(function (response) {
        if (response.status !== 'success' || !response.data || !response.data.warnings) return;
        if (nonce) {
            params.delete('payment_return');
            history.replaceState(null, '', window.location.pathname + (params.toString() ? '?' + params.toString() : '') + window.location.hash);
        }
        const warnings = response.data.warnings;
        if (!modal || !warnings.length) return;
        const expired = warnings.some(function (warning) { return warning.expired; });
        document.getElementById('schedule-payment-title').textContent = expired ? 'Your payment card has expired' : 'Your payment card expires this month';
        if (expired) modal.style.borderColor = '#df6b6b';
        const details = modal.querySelector('.payment-warning-details');
        warnings.forEach(function (warning) {
            const p = document.createElement('p');
            p.textContent = 'Your card ending ' + warning.last4 + (warning.expired ? ' expired in ' : ' expires at the end of ') + warning.expiry + '. Please update your payment method in Stripe to keep your payments running smoothly.';
            details.appendChild(p);
        });
        modal.querySelector('.payment-warning-close').onclick = function () { modal.close(); };
        modal.querySelector('.payment-warning-dismiss').onclick = function () { modal.close(); };
        modal.showModal();
    });
});
